import { inject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { UserMessageService } from "../../services/userMessageService";
import { WhiteLabelAPI } from "../../services/whitelabelAPI";
import { AccountAPI } from "../../services/accountAPI";
@inject(Router, WhiteLabelAPI, AccountAPI, UserMessageService)
export class WhiteLabelNew {
  constructor(router, api, accountApi, userMessageService) {
    this.router = router;
    this.api = api;
    this.accountApi = accountApi;

    this.userMessageService = userMessageService;

    this.saving = false;
    this.loading = false;
    this.url = window.location.origin;
    this.url = this.url.replace(/(^\w+:|^)\/\//, "");
    this.subscription = "UNLIMITED";
    this.currencySign = "$";
    this.basicFee = 0;
    this.unlimitedFee = 0;
    this.basicPerUserFee = 0;
    this.recaptcha_site_key = null;
    this.gReCaptchaResponse = "";

    this.home_url_new = window.location.origin;
    this.home_url = window.home_url;
    this.privacy_url = this.home_url_new + "/#/visitor/privacypolicy";
    this.tos_url = this.home_url_new + "/#/visitor/termsandcondition";
    this.wl_aggrement = "https://www.magnfi.com/white-label-user-agreement/";

    this.isMagnfi = false;
  }

  activate() {
    this.loading = true;
    this.reset();

    this.accountApi.getCurrencyCode(
      this.url,
      (data) => {
        this.currencyCode = data;

        if (this.currencyCode == "gbp") this.currencySign = "\u00A3";
      },
      () => {}
    );

    const style = document.createElement("style");
    style.innerHTML = "footer article{ display: none; }";
    document.head.appendChild(style);

    this.api.isWLRFlagEnabled(
      this.getUrl(),
      (data) => {

        if (data == false) {
          this.router.navigate("");
        } else if (data == true) {
          this.api.getWLSignupParams(
            this.apiKeySuccess.bind(this),
            this.saveLoadError.bind(this)
          );
        }
      },
      () => {}
    );
  }

  getUrl() {
    var data = {
      url: this.url,
    };

    return data;
  }

  detached() {
    const style = document.createElement("style");
    style.innerHTML = "footer article { display: block; }";
    document.head.appendChild(style);
  }

  reset() {
    this.businessName = null;
    this.billingAddress = null;
    this.contactPhone = null;
    this.contactEmail = null;
    this.contactFirstName = null;
    this.contactLastName = null;
  }

  onVerified(response) {
    this.gReCaptchaResponse = response;
  }

  signupError(msg) {
    this.saving = false;
    this.userMessageService.setUserError("wlsignup", msg);
  }

  save() {
    if (this.validate()) {
      if (this.gReCaptchaResponse == "") {
        this.signupError("Please resolve the captcha");
        return;
      }

      this.saving = true;

      this.stripe.createToken(this.card, { name: this.cardholderName }).then(
        function (result) {
          if (result.error) {
            // Inform the user if there was an error
            this.saving = false;
            this.displayError.textContent = result.error.message;
          } else {
            // Send the token to your server
            this.api.create(
              this.getWhiteLabelData(result.token.id),
              this.saveLoadSuccess.bind(this),
              this.saveLoadError.bind(this)
            );
          }
        }.bind(this)
      );
    }
  }

  apiKeySuccess(
    key,
    redirect_url,
    starter_base_fee,
    starter_per_user_fee,
    unlimited_base_fee,
    recaptcha_site_key
  ) {

    this.renderStripe(key);

    this.redirect_url = redirect_url;
    this.basicFee = starter_base_fee;
    this.basicPerUserFee = starter_per_user_fee;
    this.unlimitedFee = unlimited_base_fee;
    this.recaptcha_site_key = recaptcha_site_key;
    this.loading = false;

    if (this.basicFee) {
      this.isMagnfi = true;
    }
  }

  saveLoadSuccess(id) {
    if (this.saving) {
      this.router.navigate(this.redirect_url);
    }
    this.saving = false;
    this.loading = false;
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError("wlsignup", msg);
    this.loading = false;
    this.saving = false;
  }

  getWhiteLabelData(payment_token) {
    var data = {
      business_name: this.businessName,
      billing_addr: this.billingAddress,
      contact_first_name: this.contactFirstName,
      contact_last_name: this.contactLastName,
      contact_email: this.contactEmail,
      contact_phone: this.contactPhone,
      payment_token: payment_token,
      subscription_plan: this.subscription,
      g_recaptcha_response: this.gReCaptchaResponse,
    };

    return data;
  }

  validate() {
    var pass = true;

    if (this.businessName === null || this.businessName.trim() == "") {
      this.userMessageService.setUserError(
        "wlsignup",
        "Business Name is empty"
      );
      pass = false;
    }

    if (this.billingAddress === null || this.billingAddress.trim() == "") {
      this.userMessageService.setUserError(
        "wlsignup",
        "Billing Address is empty"
      );
      pass = false;
    }

    if (this.contactFirstName === null || this.contactFirstName.trim() == "") {
      this.userMessageService.setUserError(
        "wlsignup",
        "Contact First Name is empty"
      );
      pass = false;
    }

    if (this.contactLastName === null || this.contactLastName.trim() == "") {
      this.userMessageService.setUserError(
        "wlsignup",
        "Contact Last Name is empty"
      );
      pass = false;
    }

    if (this.contactEmail === null || this.contactEmail.trim() == "") {
      this.userMessageService.setUserError(
        "wlsignup",
        "Contact Email is empty"
      );
      pass = false;
    }

    if (this.contactPhone === null || this.contactPhone.trim() == "") {
      this.userMessageService.setUserError(
        "wlsignup",
        "Contact Phone is empty"
      );
      pass = false;
    }

    return pass;
  }

  is_email(email) {
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emailReg.test(email);
  }

  renderStripe(key) {
    // Create a Stripe client
    this.stripe = Stripe(key);

    // Create an instance of Elements
    this.elements = this.stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: "#32325d",
        lineHeight: "24px",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    };

    // Create an instance of the card Element
    this.card = this.elements.create("card" /*, { style: style }*/);

    // Add an instance of the card Element into the `card-element` <div>
    this.card.mount("#card-element");

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener(
      "change",
      function (event) {
        if (event.error) {
          this.displayError.textContent = event.error.message;
        } else {
          this.displayError.textContent = "";
        }
      }.bind(this)
    );
  }
}
